<template>
  <div
    v-loading="loading"
    style="width: 100%"
    class="loading-box"
    element-loading-text="加载中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.6)"
  />
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      id: null,
      templateId: 1 // 简历模版id
    }
  },
  created() {
    this.getUserIdFn()
  },
  methods: {
    ...mapMutations({
      setToken: 'SET_TOKEN'
    }),
    ...mapActions(['getUserToken']),
    // 如果携带了id就是需要进行获取token的请求
    async getUserIdFn() {
      this.loading = true
      const obj = this.$route.query
      if (obj.id) this.id = obj.id // 内容id
      if (obj.templateId) this.templateId = obj.templateId // 简历模版id
      if (obj.userId) await this.getUserTokenFn(obj.userId) // 用户id
    },
    // 获取用户token方法
    async getUserTokenFn(id) {
      const res = await this.getUserToken({ id })
      this.setToken(res.access_token)
      sessionStorage.setItem('token', res.access_token)
      localStorage.setItem('auditStatus', true)
      this.loading = false
      this.$router.push({
        path: `/resume/createWordResume`,
        query: { id: this.id, templateId: this.templateId }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.loading-box
  position fixed
  left 0
  top 0
  width 100%
  height 100%
  z-index 10
</style>

